module.exports = __webpack_public_path__ + "static/ai-2-4b96b1d40f90447295c9667187a9e764.png";